// frontend/src/components/FinanceReport/Accounting/components/accounts/AccountsTab.jsx

import { useSearchParams } from "react-router-dom";
import ClientsTab from "./clients/ClientsTab";
import SuppliersTab from "./suppliers/SuppliersTab";
import CompanyAccountsTab from "./company-accounts/CompanyAccountsTab";

const subTabs = [
  { id: "clients", label: "Клиенты" },
  { id: "suppliers", label: "Поставщики" },
  { id: "company", label: "Счета компании" },
];

export default function AccountsTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = searchParams.get("subtab") || "company";

  const setActive = (id) => {
    setSearchParams({ tab: "accounts", subtab: id });
  };

  return (
    <div>
      <div className="mb-4 inline-flex flex-wrap gap-1 rounded-xl bg-slate-100 p-1">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActive(tab.id)}
            className={`rounded-lg px-4 py-1.5 text-sm font-medium transition ${
              active === tab.id
                ? "bg-white text-slate-900 shadow-sm"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {active === "clients" && <ClientsTab />}
      {active === "suppliers" && <SuppliersTab />}
      {active === "company" && <CompanyAccountsTab />}
    </div>
  );
}